import React from 'react';
import I18n from '@/modules/i18n';
import * as Routes from '@/modules/routes';
import Icon from '@/components/ui/Icon';
import Text from '@/components/ui/Text';
import SettingsShortcut from '@/components/common/ShortcutButtons/SettingsShortcut';
import useFlags from '@/hooks/useFlags';
import useGradesTableStore from './store/useGradesTableStore';
import FilterButton from './FilterButton/FilterButton';

const Header = () => {
  const classroom = useGradesTableStore(state => state.classroom);
  const programId = useGradesTableStore(state => state.programId);
  const lesson = useGradesTableStore(state => state.lesson);
  const unit = useGradesTableStore(state => state.unit);
  const showBenchmarksButton = useGradesTableStore(state => state.showBenchmarksButton);
  const { gradingFilters } = useFlags();

  const handleExportCsv = () => {
    const url = Routes.export_csv_teacher_score_path(classroom.id, {
      format: 'csv',
      lesson_id: lesson?.id,
      program_id: programId,
      unit_id: unit?.id,
    });
    window.location.href = url;
  };

  const handleBenchmarksClick = () => {
    window.location.href = Routes.benchmarks_teacher_score_path(classroom.id);
  };

  return (
    <div className="tw-flex tw-justify-between tw-items-center">
      <h1 className="tw-inline-block">{I18n.t('grades')}</h1>
      <div className="tw-flex tw-items-center">
        {showBenchmarksButton && (
          <button
            className="btn btn--outline-purple tw-mr-4"
            type="button"
            onClick={handleBenchmarksClick}
          >
            <div className="tw-flex tw-items-center">
              <Icon className="tw-flex tw-mr-1" icon="Benchmark" />
              <Text size="xs">{I18n.t('view_student_benchmarks_report')}</Text>
            </div>
          </button>
        )}

        <button
          className="btn btn--outline-purple tw-mr-4"
          type="button"
          onClick={handleExportCsv}
        >
          <div className="tw-flex tw-items-center">
            <Icon className="tw-block tw-pr-2" icon="Download" size={16} />
            <Text size="xs">Export to CSV</Text>
          </div>
        </button>

        {gradingFilters && <FilterButton />}
        <SettingsShortcut newIcon settingsType="grades" />
      </div>
    </div>
  );
};

export default Header;
